<template>
  <div class="modal-wrap large" :data-modal="modalKey" style="display: none;" :ref="'modal'">
    <div class="modal-wrap-view">
      <!-- .modal -->
      <div class="p-scoutMessageModal modal ptb30 plr20" style="position: relative;">
        <p class="fw-b fz170 ta-c">スカウト定型文を使う</p>
        <div class="p-scoutMessageModal-container mt20">
          <div>
            <button type="button" class="hov p-scoutMessageModal-new-button" @click="newTemplate">
              <span>オリジナルを新規作成</span>
              <span class="p-scoutMessageModal-new-button-icon"></span>
            </button>
            <ul class="p-scoutMessageModal-editable-template-list mt10">
              <li :class="{ isEditing: currentEditTemplate === index, isActive: selectedTemplate.editable && selectedTemplate.id === item.id }" :ref="'templateListItem'" v-for="(item, index) in editableTemplateList" :key="index" @click="selectTemplate(item)">
                <div class="js-tippyTooltip">
                  <button type="button" class="p-scoutMessageModal-default-pin-button js-tippyTooltip-button hov" :class="{ isActive: defaultTemplateId === item.id }" @click="setDefault(index)"><img src="/img/scout-template/icon-pin.svg"></button>
                  <div class="js-tippyTooltip-content">
                    <div class="tippy-content-inner -black">
                      <div class="d-b lh140 fw-b c-white fz85 p10">この定型文をデフォルトにする</div>
                    </div>
                  </div>
                </div>
                <div class="p-scoutMessageModal-editable-template-list-input">
                  <span v-show="currentEditTemplate !== index">{{ item.title }}</span>
                  <input type="text" :value="item.title" :ref="'titleInput'" @keyup.enter="blurInput($event)" @blur="updateTitle(index, $event)" v-show="currentEditTemplate === index">
                </div>
                <button type="button" class="p-scoutMessageModal-editable-template-list-iconButton hov" @click="toggleInput(index)"><i class="icon-status-pen"></i></button>
                <button type="button" class="p-scoutMessageModal-editable-template-list-iconButton hov" @click="deleteTemplate(item.id)"><i class="icon-delete"></i></button>
              </li>
            </ul>
            <div class="mt15 pb15 bt-black50"></div>
            <ul class="p-scoutMessageModal-static-template-list">
              <li v-for="(item, index) in ciyTemplateList" :key="item.id" @click="selectTemplate(item)" :class="{ isActive: !selectedTemplate.editable && selectedTemplate.id === item.id }">
                <div class="js-tippyTooltip">
                  <button type="button" class="p-scoutMessageModal-default-pin-button js-tippyTooltip-button hov" :class="{ isActive: !defaultTemplateId }" @click="deleteDefault"><img src="/img/scout-template/icon-pin.svg"></button>
                  <div class="js-tippyTooltip-content">
                    <div class="tippy-content-inner -black">
                      <div class="d-b lh140 fw-b c-white fz85 p10">この定型文をデフォルトにする</div>
                    </div>
                  </div>
                </div>
                <span class="fz85 fw-b">{{ item.title }}</span>
              </li>
            </ul>
          </div>
          <div v-if="!!selectedTemplate.id">
            <div class="p-scoutMessageModal-content-box">
              <div class="p-scoutMessageModal-content-box-head pb15">
                <div class="p-scoutMessageModal-content-box-subject">
                  <input type="text" placeholder="件名を入力ください" :value="selectedTemplate.subject" v-if="selectedTemplate.editable" :ref="'subjectInput'">
                  <div v-else>{{ selectedTemplate.subject }}</div>
                </div>
                <div class="p-scoutMessageModal-content-box-copylist" v-if="selectedTemplate.editable">
                  <button type="button" class="hov" @click="isCopyListShow = !isCopyListShow"><span>別の定型文からコピー</span><span class="v-arrow-down"></span></button>
                  <ul class="p-scoutMessageModal-content-box-copylist-body" v-show="isCopyListShow">
                    <li v-for="(item, index) in ciyTemplateList" class="hov" @click="copyTemplate(item)">{{ item.title }}</li>
                  </ul>
                </div>
              </div>
              <textarea class="p-scoutMessageModal-content-box-content" placeholder="本文を入力ください" rows="20" :value="selectedTemplate.content" v-if="selectedTemplate.editable" :ref="'contentInput'"></textarea>
              <div class="p-scoutMessageModal-content-box-content" v-else><pre>{{ selectedTemplate.content }}</pre></div>
              <div>
                <button type="button" class="p-scoutMessageModal-save-change-button hov" @click="updateSubjectAndContent(selectedTemplate)" v-if="selectedTemplate.editable">変更を保存する</button>
              </div>
            </div>
            <div class="mt15">
              <p class="c-black80 fw-b fz85 ta-c" v-show="!selectedTemplate.editable"><span v-pre>{{　}}の中の内容は、登録情報などから自動的に挿入されます</span></p>
              <p class="c-black80 fw-b fz85" v-show="selectedTemplate.editable"><span v-pre>{{応募者名}} {{企業名}} {{担当者名}} {{本社所在地}} {{電話番号}} を入れると、挿入時にシステム登録情報から自動的に変換されます。</span></p>
            </div>
            <div class="mt15">
              <button type="button" class="p-scoutMessageModal-use-template-button hov" @click="useTemplate(selectedTemplate)">この定型文を使う</button>
            </div>
          </div>
        </div>
        <div class="p-scoutMessageModal-loading-overlay" v-show="isLoading"><img src="/img/mypage/loader.png" width="32" height="32" alt="アップロード中"></div>
      </div>
    </div>
    <!-- .black-back -->
    <div class="black-back modal-close"></div>
  </div>
</template>

<script>
const PATH_FETCH_DATA = '/company/ajax/scout/message_template/fetch_data'
const PATH_NEW_TEMPLATE = '/company/ajax/scout/message_template/new_template';
const PATH_UPDATE_TEMPLATE = '/company/ajax/scout/message_template/update_template';
const PATH_DELETE_TEMPLATE = '/company/ajax/scout/message_template/delete_template';
const PATH_SET_DEFAULT = '/company/ajax/scout/message_template/set_default';
const PATH_DELETE_DEFAULT = '/company/ajax/scout/message_template/delete_default';
const PATH_RENDER_TEMPLATE = '/company/ajax/scout/message_template/render_template';

export default {
  props: {
    modalKey: {
      type: String,
      required: true,
    },
    subjectInputKey: {
      type: String,
      required: true,
    },
    contentInputKey: {
      type: String,
      required: true,
    },
    recruitId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      editableTemplateList: [],
      ciyTemplateList: [],
      currentEditTemplate: -1,
      defaultTemplateId: null,
      selectedTemplate: {},
      isCopyListShow: false,
      isLoading: true,
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const res = await fetch(PATH_FETCH_DATA, {
        method: 'GET',
        headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content },
      });
      const json = await res.json();
      this.editableTemplateList = json.data.template;
      this.ciyTemplateList = json.data.ciy_template;
      this.defaultTemplateId = json.data.default_template?.id;
      this.selectedTemplate = json.data.default_template || this.ciyTemplateList[0];
      this.isLoading = false;
    },

    blurInput(event) {
      event.target.blur();
    },

    toggleInput(index) {
      if (this.currentEditTemplate === -1) {
        this.currentEditTemplate = index;
        this.$nextTick(() => {
          const input = this.$refs.titleInput[index];
          input.focus();
          input.setSelectionRange(input.value.length, input.value.length);
        });
      } else {
        this.currentEditTemplate = -1;
      }
    },

    async newTemplate() {
      this.isLoading = true;
      const res = await fetch(PATH_NEW_TEMPLATE, {
        method: 'POST',
        headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content },
      });
      if (res.ok) {
        const json = await res.json();
        this.editableTemplateList.push(json.data.template);
      }
      this.isLoading = false;
    },

    async updateTemplate({ id, title, subject, content }) {
      this.isLoading = true;
      const res = await fetch(PATH_UPDATE_TEMPLATE, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id, title, subject, content }),
      });
      if (res.ok) {
        const json = await res.json();
        this.editableTemplateList = json.data.template;
        return json;
      }
      this.isLoading = false;
    },

    async deleteTemplate(id) {
      this.isLoading = true;
      const res = await fetch(PATH_DELETE_TEMPLATE, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id }),
      });
      if (res.ok) {
        const json = await res.json();
        this.editableTemplateList = json.data.template;
        this.selectedTemplate = this.ciyTemplateList[0];
      }
      this.isLoading = false;
    },

    async updateTitle(index, event) {
      this.isLoading = true;
      this.currentEditTemplate = -1;
      const template = { ...this.editableTemplateList[index] };
      await this.updateTemplate({ id: template.id, title: event.target.value });
      this.isLoading = false;
    },

    async updateSubjectAndContent(template) {
      this.isLoading = true;
      const id = template.id;
      const subject = this.$refs.subjectInput.value;
      const content = this.$refs.contentInput.value;
      const res = await this.updateTemplate({ id, subject, content });
      this.selectedTemplate = res?.data?.target_template;
      this.isLoading = false;
    },

    async setDefault(index) {
      this.isLoading = true;
      if (this.defaultTemplateId !== this.editableTemplateList[index].id) {
        const res = await fetch(PATH_SET_DEFAULT, {
          method: 'PATCH',
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ id: this.editableTemplateList[index].id }),
        });
        if (res.ok) {
          this.defaultTemplateId = this.editableTemplateList[index].id;
        }
      }
      this.isLoading = false;
    },

    async deleteDefault() {
      this.isLoading = true;
      const res = await fetch(PATH_DELETE_DEFAULT, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/json',
        },
      });
      if (res.ok) {
        this.defaultTemplateId = null;
      }
      this.isLoading = false;
    },

    async renderTemplate({ subject, content }) {
      this.isLoading = true;
      const res = await fetch(PATH_RENDER_TEMPLATE, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ subject, content, recruit_id: this.recruitId }),
      });
      if (res.ok) {
        const json = await res.json();
        return json;
      }
      this.isLoading = false;
    },

    selectTemplate(template) {
      this.selectedTemplate = template;
    },

    copyTemplate(template) {
      this.isCopyListShow = false;
      this.$nextTick(() => {
        this.$refs.subjectInput.value = template.subject;
        this.$refs.contentInput.value = template.content;
      });
    },

    async useTemplate(template) {
      this.isLoading = true;
      
      // 編集可能なテンプレートで、かつフォームが表示されている場合は
      // 入力フィールドから直接値を取得
      let subject = template.subject;
      let content = template.content;
      
      if (template.editable && this.$refs.subjectInput && this.$refs.contentInput) {
        subject = this.$refs.subjectInput.value;
        content = this.$refs.contentInput.value;
      }
      
      const res = await this.renderTemplate({ subject, content });
      const subjectInupt = document.querySelector(`[data-key="${this.subjectInputKey}"]`);
      const contentInupt = document.querySelector(`[data-key="${this.contentInputKey}"]`);
      subjectInupt.value = res?.data?.subject;
      contentInupt.value = res?.data?.content;
      $(this.$refs.modal).hide();
      this.isLoading = false;
    },
  }
}
</script>
